/* =========================================================================
   ISABEL DEAL — scripts du thème (vanilla JS, sans dépendance)
   Panier Ajax · variantes · favoris · recherche prédictive · filtres · animations
   ========================================================================= */
(() => {
  'use strict';

  const CFG = window.ISABEL || { routes: {}, strings: {}, currency: 'EUR', freeShipping: 0 };
  const S = CFG.strings || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (CFG.routes.root || '/').replace(/\/$/, '');

  const money = (cents) => {
    try {
      return new Intl.NumberFormat((CFG.locale || 'fr') + '-FR', { style: 'currency', currency: CFG.currency || 'EUR' }).format((cents || 0) / 100);
    } catch (e) { return ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* stockage indisponible */ } }
  };
  const sized = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#Toast'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Tiroirs, overlays & modales ---------- */
  const openLayers = new Set();
  let lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    openLayers.add(el); document.body.classList.add('is-locked');
    const f = el.querySelector('input[type="search"], button, a[href], input, select');
    setTimeout(() => f && f.focus({ preventScroll: true }), 80);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    openLayers.delete(el);
    if (!openLayers.size) document.body.classList.remove('is-locked');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const zoom = $('[data-zoom-overlay].is-open'); if (zoom) { zoom.classList.remove('is-open'); document.body.classList.remove('is-locked'); return; }
    Array.from(openLayers).pop() && closeLayer(Array.from(openLayers).pop());
  });

  /* ---------- En-tête ---------- */
  function initHeader() {
    const wrap = $('.section-header'); const header = $('[data-header]');
    if (!header || !wrap) return;
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      const hide = y > 320 && y > lastY && !openLayers.size;
      wrap.classList.toggle('is-hidden', hide);
      document.body.classList.toggle('header-hidden', hide);
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  function initAnnouncement() {
    const bar = $('[data-announcement]'); if (!bar) return;
    const items = $$('.announcement__item', bar); if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
    }, parseInt(bar.dataset.interval, 10) || 5000);
  }

  /* ---------- Animations d'apparition & parallaxe ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function reveal(scope = document) {
    $$('[data-reveal]:not(.is-in)', scope).forEach((el) => { if (io && !reduceMotion) io.observe(el); else el.classList.add('is-in'); });
  }
  function initParallax() {
    if (reduceMotion || window.innerWidth < 990) return;
    const els = $$('[data-parallax]'); if (!els.length) return;
    let ticking = false;
    const run = () => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
        const img = el.querySelector('img'); if (!img) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform = `translate3d(0, ${(p * -40).toFixed(1)}px, 0) scale(1.08)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- Panier ---------- */
  const Cart = {
    state: null,
    async fetch() {
      const r = await fetch(root + '/cart.js', { headers: { Accept: 'application/json' } });
      this.state = await r.json(); this.render(); return this.state;
    },
    async add(id, quantity = 1, btn) {
      btn && btn.classList.add('is-loading');
      try {
        const r = await fetch(root + '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
        });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || 'Erreur');
        await this.fetch();
        toast(S.added || 'Ajouté au panier');
        if (!document.body.classList.contains('template-cart')) openLayer($('#CartDrawer'));
        return true;
      } catch (e) { toast(e.message); return false; }
      finally { btn && btn.classList.remove('is-loading'); }
    },
    async change(key, quantity) {
      const r = await fetch(root + '/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const data = await r.json();
      if (!r.ok) { toast(data.description || 'Erreur'); return; }
      this.state = data; this.render();
    },
    render() {
      const c = this.state; if (!c) return;
      $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.classList.toggle('is-visible', c.item_count > 0); });
      $$('[data-cart-count-text]').forEach((el) => { el.textContent = '(' + c.item_count + ')'; });
      $$('[data-cart-subtotal]').forEach((el) => { el.textContent = money(c.total_price); });
      shipBar(c.total_price);
      const list = $('[data-cart-items]'); const foot = $('[data-cart-foot]');
      if (!list) return;
      if (!c.items.length) {
        list.innerHTML = `<div class="cart-empty"><p class="display h-xl">${esc(S.empty || 'Votre panier est vide')}</p>
          <a class="btn" href="${esc(CFG.routes.products || '/collections/all')}">Découvrir la boutique</a></div>`;
        foot && (foot.hidden = true); return;
      }
      foot && (foot.hidden = false);
      list.innerHTML = c.items.map((it) => {
        const variant = it.product_has_only_default_variant ? '' : (it.options_with_values || []).map((o) => esc(o.value)).join(' · ');
        const sale = it.original_line_price > it.final_line_price;
        return `<div class="cart-item" data-key="${esc(it.key)}">
          <a class="cart-item__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(sized(it.image, 240))}" alt="${esc(it.product_title)}" loading="lazy" width="240" height="320">` : ''}</a>
          <div class="cart-item__body">
            <div class="card__row"><a class="cart-item__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
              <span class="price${sale ? ' price--sale' : ''}">${sale ? `<s class="price__compare">${money(it.original_line_price)}</s>` : ''}<span class="price__current">${money(it.final_line_price)}</span></span></div>
            ${variant ? `<p class="cart-item__variant" style="margin:0">${variant}</p>` : ''}
            <div class="cart-item__bottom">
              <div class="qty"><button type="button" data-cart-qty="-1" aria-label="Diminuer">−</button>
                <input type="number" value="${it.quantity}" min="0" aria-label="Quantité" data-cart-input>
                <button type="button" data-cart-qty="1" aria-label="Augmenter">+</button></div>
              <button type="button" class="remove-link" data-cart-remove>Retirer</button>
            </div>
          </div></div>`;
      }).join('');
    }
  };
  function shipBar(total) {
    const th = CFG.freeShipping || 0;
    $$('[data-ship-bar]').forEach((bar) => {
      if (!th) { bar.hidden = true; return; }
      const left = Math.max(0, th - total);
      $('[data-ship-text]', bar).textContent = left > 0 ? (S.freeShipLeft || '').replace('[amount]', money(left)) : S.freeShipOk;
      $('[data-ship-fill]', bar).style.transform = `scaleX(${Math.min(1, total / th).toFixed(3)})`;
    });
  }
  function initCart() {
    const json = $('#CartJSON');
    if (json) { try { Cart.state = JSON.parse(json.textContent); Cart.render(); } catch (e) { Cart.fetch(); } }
    const pageTotal = $('[data-cart-page-total]'); if (pageTotal) shipBar(parseInt(pageTotal.textContent, 10) || 0);
    // Page panier : steppers
    $$('#CartPageForm [data-qty-step]').forEach((b) => b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('[data-qty-input]');
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyStep, 10));
      const f = $('#CartPageForm'); const u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; f.appendChild(u); f.submit();
    }));
    const drawer = $('#CartDrawer'); if (!drawer) return;
    drawer.addEventListener('click', (e) => {
      const item = e.target.closest('.cart-item'); if (!item) return;
      const key = item.dataset.key; const input = $('[data-cart-input]', item);
      if (e.target.closest('[data-cart-remove]')) { item.classList.add('is-removing'); setTimeout(() => Cart.change(key, 0), 300); }
      const step = e.target.closest('[data-cart-qty]');
      if (step) Cart.change(key, Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.cartQty, 10)));
    });
    drawer.addEventListener('change', (e) => {
      if (!e.target.matches('[data-cart-input]')) return;
      Cart.change(e.target.closest('.cart-item').dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  /* ---------- Favoris ---------- */
  const WKEY = 'isabel_deal_wishlist';
  const Wishlist = {
    list() { return store.get(WKEY, []); },
    has(h) { return this.list().includes(h); },
    toggle(h) {
      let l = this.list(); const on = !l.includes(h);
      l = on ? [h, ...l] : l.filter((x) => x !== h); store.set(WKEY, l); this.sync(); return on;
    },
    sync() {
      const l = this.list();
      $$('[data-wishlist-toggle]').forEach((b) => { const on = l.includes(b.dataset.wishlistToggle); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
      $$('[data-wishlist-count]').forEach((el) => { el.textContent = l.length; el.classList.toggle('is-visible', l.length > 0); });
    },
    async renderPage() {
      const grid = $('[data-wishlist-grid]'); if (!grid) return;
      const l = this.list(); const empty = $('[data-wishlist-empty]');
      if (!l.length) { grid.innerHTML = ''; empty && (empty.hidden = false); return; }
      const html = await Promise.all(l.map(async (h) => {
        try { const r = await fetch(`${root}/products/${encodeURIComponent(h)}?view=card`); if (!r.ok) throw 0; return await r.text(); }
        catch (e) { return ''; }
      }));
      grid.innerHTML = html.join(''); empty && (empty.hidden = grid.children.length > 0);
      reveal(grid); this.sync();
    }
  };

  /* ---------- Recherche prédictive ---------- */
  function initSearch() {
    const ov = $('#SearchOverlay'); if (!ov) return;
    const input = $('[data-predictive-input]', ov); const out = $('[data-predictive-results]', ov);
    let ctrl;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      ctrl && ctrl.abort(); ctrl = new AbortController();
      try {
        const url = `${CFG.routes.predictive || '/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
        const r = await fetch(url, { signal: ctrl.signal }); const d = await r.json();
        const items = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!items.length) { out.innerHTML = `<p class="search-results__empty">${esc((S.noResults || '').replace('[q]', q))}</p>`; return; }
        out.innerHTML = `<div class="search-results">${items.map((p, i) => {
          const img = (p.featured_image && p.featured_image.url) || p.image || '';
          const cmp = parseFloat(p.compare_at_price_max || 0); const pr = parseFloat(p.price || 0);
          return `<a class="search-result" href="${esc(p.url)}" style="animation-delay:${i * 40}ms">
            <span class="search-result__img">${img ? `<img src="${esc(sized(img, 400))}" alt="${esc(p.title)}" loading="lazy">` : ''}</span>
            <span class="card__title">${esc(p.title)}</span>
            <span class="price${cmp > pr ? ' price--sale' : ''}"><span class="price__current">${money(Math.round(pr * 100))}</span>${cmp > pr ? `<s class="price__compare">${money(Math.round(cmp * 100))}</s>` : ''}</span></a>`;
        }).join('')}</div>
        <p style="padding-bottom:32px"><a class="link" href="${esc(CFG.routes.search)}?q=${encodeURIComponent(q)}&type=product">Voir tous les résultats</a></p>`;
      } catch (e) { if (e.name !== 'AbortError') out.innerHTML = ''; }
    }, 220);
    input.addEventListener('input', run);
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(section) {
    const jsonEl = $('[data-product-json]', section); if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', section);
    const fieldsets = $$('[data-option]', section);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const addLabel = $('[data-add-label]', section);
    const gallery = $('[data-gallery]', section);
    let lastMedia = null;

    const selected = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const find = (sel) => data.variants.find((v) => v.options.every((o, i) => sel[i] === o));

    function availability(sel) {
      fieldsets.forEach((fs, i) => {
        $$('input', fs).forEach((inp) => {
          const ok = data.variants.some((v) => v.available && v.options[i] === inp.value && v.options.slice(0, i).every((o, j) => o === sel[j]));
          inp.closest('label').classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function stock(v) {
      const el = $('[data-stock]', section); if (!el) return;
      el.classList.remove('is-low', 'is-out');
      if (!v) { el.textContent = S.selectSize || ''; return; }
      if (!v.available) { el.textContent = S.outStock; el.classList.add('is-out'); return; }
      if (v.inventory !== null && v.inventory > 0 && v.inventory <= 3) { el.textContent = S.lowStock.replace('[n]', v.inventory); el.classList.add('is-low'); return; }
      el.textContent = S.inStock;
    }
    function showMedia(id) {
      if (!gallery || !id || id === lastMedia) return;
      const item = gallery.querySelector(`[data-media-id="${id}"]`); if (!item) return;
      lastMedia = id;
      if (window.innerWidth < 990) { gallery.prepend(item); gallery.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      gallery.classList.add('is-swapping');
      $$('.gallery__item', gallery).forEach((g) => g.classList.add('is-fading'));
      setTimeout(() => { gallery.prepend(item); $$('.gallery__item', gallery).forEach((g) => g.classList.remove('is-fading')); }, 260);
    }
    function update(push = true) {
      const sel = selected(); const v = find(sel);
      availability(sel);
      fieldsets.forEach((fs, i) => { const lbl = $('[data-option-label]', fs); if (lbl) lbl.textContent = sel[i] || ''; });
      stock(v);
      if (!v) { addBtn.disabled = true; addLabel.textContent = S.unavailable; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; addLabel.textContent = v.available ? S.addToCart : S.soldOut;
      const wrap = $('[data-price-wrap]', section);
      if (wrap) {
        const sale = v.compare_at_price > v.price;
        wrap.classList.toggle('price--sale', sale);
        $('[data-price]', wrap).textContent = money(v.price);
        const cmp = $('[data-compare]', wrap); cmp.hidden = !sale; if (sale) cmp.innerHTML = `<span class="visually-hidden">Prix initial</span>${money(v.compare_at_price)}`;
        const d = $('[data-discount]', wrap); if (d) { d.hidden = !sale; if (sale) d.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %'; }
      }
      const sp = $('[data-sticky-price]', section); if (sp) sp.textContent = money(v.price);
      const sku = $('[data-sku]', section); if (sku) sku.textContent = v.sku || '';
      if (v.media) showMedia(v.media);
      if (push) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    fieldsets.forEach((fs) => fs.addEventListener('change', () => update()));
    update(false);

    form && form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = find(selected());
      if (!v) { toast(S.selectSize); return; }
      if (!v.available) return;
      Cart.add(v.id, 1, addBtn);
    });

    // Galerie : compteur mobile + zoom
    const counter = $('[data-gallery-counter]', section);
    if (gallery && counter) gallery.addEventListener('scroll', debounce(() => {
      const i = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
      counter.textContent = `${i} / ${gallery.children.length}`;
    }, 60), { passive: true });
    const zoom = $('[data-zoom-overlay]', section);
    if (gallery && zoom) {
      gallery.addEventListener('click', (e) => {
        const it = e.target.closest('[data-zoom]'); if (!it || window.innerWidth < 990) return;
        $('[data-zoom-img]', zoom).src = it.dataset.zoom; zoom.classList.add('is-open'); document.body.classList.add('is-locked'); zoom.scrollTop = 0;
      });
      zoom.addEventListener('click', () => { zoom.classList.remove('is-open'); if (!openLayers.size) document.body.classList.remove('is-locked'); });
    }

    // Barre d'achat mobile
    const sticky = $('[data-sticky-atc]', section);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        const v = find(selected());
        if (!v) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); toast(S.selectSize); return; }
        Cart.add(v.id, 1, $('[data-sticky-add]', sticky));
      });
    }
  }

  /* ---------- Collection : filtres, tri, chargement ---------- */
  function initCollection(rootEl) {
    if (!rootEl) return;
    const sectionId = rootEl.dataset.sectionId;
    const density = store.get('isabel_density', '4');
    const applyDensity = (d) => {
      const g = $('#ProductGrid', rootEl); if (g) g.dataset.density = d;
      $$('.density button', rootEl).forEach((b) => b.setAttribute('aria-pressed', b.dataset.density === d));
    };
    applyDensity(density);

    async function load(url, push = true) {
      const container = $('[data-grid-container]', rootEl); container && container.classList.add('grid-loading');
      const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      try {
        const html = await (await fetch(u)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-grid-container]', '[data-active-filters]', '[data-results-count]', '#FacetsDrawer .drawer__body'].forEach((sel) => {
          const a = $(sel, rootEl); const b = $(sel, doc); if (a && b) a.innerHTML = b.innerHTML;
        });
        u.searchParams.delete('section_id');
        if (push) history.pushState({ facets: true }, '', u.pathname + u.search);
        applyDensity(store.get('isabel_density', '4')); reveal(rootEl); Wishlist.sync();
      } catch (e) { location.href = url; }
      finally { const c = $('[data-grid-container]', rootEl); c && c.classList.remove('grid-loading'); }
    }
    const formUrl = () => {
      const form = $('[data-facets-form]', rootEl); const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
      return location.pathname + '?' + params.toString();
    };
    rootEl.addEventListener('change', debounce((e) => {
      if (e.target.matches('[data-sort-select]')) { const m = $('[data-sort-mirror]', rootEl); if (m) m.value = e.target.value; }
      if (e.target.closest('[data-facets-form]') || e.target.matches('[data-sort-select]')) load(formUrl());
    }, 350));
    rootEl.addEventListener('click', async (e) => {
      const link = e.target.closest('[data-facet-link]');
      if (link) { e.preventDefault(); load(link.href); closeLayer($('#FacetsDrawer')); return; }
      const d = e.target.closest('.density button');
      if (d) { store.set('isabel_density', d.dataset.density); applyDensity(d.dataset.density); return; }
      const more = e.target.closest('[data-load-more-btn]');
      if (more) {
        e.preventDefault(); more.classList.add('is-loading');
        const u = new URL(more.href, location.origin); u.searchParams.set('section_id', sectionId);
        try {
          const doc = new DOMParser().parseFromString(await (await fetch(u)).text(), 'text/html');
          const grid = $('#ProductGrid', rootEl);
          $$('#ProductGrid > *', doc).forEach((card) => grid.appendChild(card));
          const nextMore = $('[data-load-more]', doc); const curMore = $('[data-load-more]', rootEl);
          if (nextMore) curMore.replaceWith(nextMore); else curMore.remove();
          reveal(grid); Wishlist.sync();
        } catch (err) { location.href = more.href; }
      }
    });
    window.addEventListener('popstate', () => load(location.href, false));
  }

  /* ---------- Compte à rebours ---------- */
  function initCountdown() {
    $$('[data-countdown]').forEach((el) => {
      const end = new Date(el.dataset.countdown.replace(' ', 'T')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        $('[data-d]', el).textContent = pad(Math.floor(s / 86400)); s %= 86400;
        $('[data-h]', el).textContent = pad(Math.floor(s / 3600)); s %= 3600;
        $('[data-m]', el).textContent = pad(Math.floor(s / 60));
        $('[data-s]', el).textContent = pad(s % 60);
      };
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Recommandations ---------- */
  function initRecommendations() {
    const sec = $('[data-recommendations]'); if (!sec || !sec.dataset.url) return;
    const run = async () => {
      try {
        const doc = new DOMParser().parseFromString(await (await fetch(sec.dataset.url)).text(), 'text/html');
        const g = $('[data-recommendations-grid]', doc);
        if (g && g.children.length) { $('[data-recommendations-grid]', sec).innerHTML = g.innerHTML; reveal(sec); Wishlist.sync(); }
      } catch (e) { /* on garde le repli */ }
      if (!$('[data-recommendations-grid]', sec).children.length) sec.hidden = true;
    };
    if ('IntersectionObserver' in window) {
      const o = new IntersectionObserver(([en]) => { if (en.isIntersecting) { o.disconnect(); run(); } }, { rootMargin: '400px' }); o.observe(sec);
    } else run();
  }

  /* ---------- Délégation des clics ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    const od = t.closest('[data-open-drawer]'); if (od) { e.preventDefault(); openLayer(document.getElementById(od.dataset.openDrawer)); return; }
    const cd = t.closest('[data-close-drawer]'); if (cd) { closeLayer(cd.closest('.drawer')); return; }
    if (t.closest('[data-open-cart]') && !document.body.classList.contains('template-cart')) { e.preventDefault(); openLayer($('#CartDrawer')); return; }
    if (t.closest('[data-open-search]')) { openLayer($('#SearchOverlay')); return; }
    if (t.closest('[data-close-search]')) { closeLayer($('#SearchOverlay')); return; }
    const om = t.closest('[data-open-modal]');
    if (om) {
      const m = document.getElementById(om.dataset.openModal); openLayer(m);
      if (om.dataset.tabOpen) { const tb = m.querySelector(`[data-tab="${om.dataset.tabOpen}"]`); tb && tb.click(); }
      return;
    }
    const cm = t.closest('[data-close-modal]'); if (cm) { closeLayer(cm.closest('.modal')); return; }
    const tab = t.closest('[data-tab]');
    if (tab) {
      const list = tab.parentElement;
      $$('[data-tab]', list).forEach((b) => { b.setAttribute('aria-selected', b === tab); const p = document.getElementById(b.dataset.tab); if (p) p.hidden = b !== tab; });
      return;
    }
    const w = t.closest('[data-wishlist-toggle]');
    if (w) {
      e.preventDefault();
      const on = Wishlist.toggle(w.dataset.wishlistToggle);
      w.classList.remove('is-pop'); void w.offsetWidth; w.classList.add('is-pop');
      toast(on ? S.wishAdded : S.wishRemoved);
      if (!on && $('[data-wishlist-grid]')) { const card = w.closest('.card'); card && card.remove(); if (!Wishlist.list().length) Wishlist.renderPage(); }
      return;
    }
    const qa = t.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      Cart.add(qa.dataset.quickAdd, 1, qa).then((ok) => { if (ok) { qa.classList.add('is-added'); setTimeout(() => qa.classList.remove('is-added'), 1500); } });
    }
  });

  /* ---------- Démarrage ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initHeader(); initAnnouncement(); initCart(); initSearch(); initCountdown(); initRecommendations();
    $$('[data-product-section]').forEach(initProduct);
    initCollection($('[data-collection-root]'));
    Wishlist.sync(); Wishlist.renderPage();
    reveal(); initParallax();
  });
  window.IsabelDeal = { Cart, Wishlist, toast, money };
})();
